// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23a5b4fc%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu Transfer Page Glass Styles
   ========================================== */

.transfer-page {
  font-family: var(--font-family);
  min-height: 100vh;
  padding: 6rem 1.5rem 4rem 1.5rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.transfer-container {
  background: var(--bg-glass-card);
  backdrop-filter: blur(20px);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-width: 600px;
  padding: 3rem 2.5rem;
  margin: 0;
}

.transfer-header {
  text-align: center;
  margin-bottom: 2.5rem;
}

.transfer-header h1 {
  color: #ffffff;
  font-size: clamp(1.75rem, 4vw, 2.25rem);
  font-weight: 800;
  margin: 0 0 0.5rem 0;
}

.transfer-header p {
  color: var(--text-muted);
  margin: 0;
  font-size: 1rem;
}

.transfer-tabs {
  display: flex;
  background: rgba(15, 23, 42, 0.7);
  border-radius: var(--radius-md);
  padding: 0.25rem;
  margin-bottom: 2.5rem;
  border: 1px solid var(--border-glass);
}

.transfer-tabs button {
  flex: 1 1;
  padding: 0.85rem 1rem;
  border: none;
  background: transparent;
  border-radius: var(--radius-sm);
  font-weight: 600;
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.3s ease;
}

.transfer-tabs button.active {
  background: var(--grad-primary);
  color: #ffffff;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);
}

.transfer-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-section label {
  font-weight: 500;
  color: var(--text-muted);
  font-size: 0.9rem;
}

.account-selector select,
.recipient-section input,
.amount-input input,
.datetime-picker input {
  width: 100%;
  padding: 1rem 1.25rem;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-md);
  font-size: 1rem;
  color: #ffffff;
  transition: all 0.3s ease;
}

.account-selector select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 1rem;
  cursor: pointer;
}

.account-selector select option {
  background: #0f172a;
  color: #ffffff;
}

.account-selector select:focus,
.recipient-section input:focus,
.amount-input input:focus,
.datetime-picker input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);
}

.recent-contacts {
  margin-top: 0.5rem;
}

.recent-contacts p {
  font-size: 0.85rem;
  color: var(--text-muted);
  margin: 0 0 0.75rem 0;
}

.contact-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.contact-chip {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 1rem 0.5rem 0.5rem;
  background: rgba(15, 23, 42, 0.4);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: all 0.2s ease;
}

.contact-chip:hover {
  background: rgba(15, 23, 42, 0.8);
  border-color: rgba(255, 255, 255, 0.2);
}

.contact-initial {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  background: var(--grad-primary);
  color: #ffffff;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.9rem;
}

.contact-info {
  display: flex;
  flex-direction: column;
}

.contact-name {
  font-weight: 600;
  font-size: 0.9rem;
  color: #ffffff;
}

.contact-details {
  font-size: 0.75rem;
  color: var(--text-muted);
}

.amount-input {
  position: relative;
  display: flex;
  align-items: center;
}

.currency-symbol {
  position: absolute;
  left: 1.25rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-primary);
  z-index: 1;
}

.amount-input input {
  padding-left: 2.75rem;
  font-size: 1.2rem;
  font-weight: 600;
}

.schedule-options {
  display: flex;
  gap: 1.5rem;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-weight: 500;
  color: #ffffff;
}

.radio-option input {
  display: none;
}

.radio-custom {
  width: 20px;
  height: 20px;
  border: 2px solid var(--border-glass);
  border-radius: 50%;
  display: inline-block;
  position: relative;
  transition: all 0.2s ease;
  background: rgba(15, 23, 42, 0.6);
}

.radio-option input:checked + .radio-custom {
  border-color: var(--color-primary);
  background: var(--color-primary);
}

.radio-option input:checked + .radio-custom::after {
  content: '';
  position: absolute;
  top: 4px;
  left: 4px;
  width: 8px;
  height: 8px;
  background: white;
  border-radius: 50%;
}

.datetime-picker {
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
}

/* Fix for date/time picker icon colors on dark theme in some browsers */
::-webkit-calendar-picker-indicator {
  filter: invert(1);
  opacity: 0.7;
}

.submit-button {
  margin-top: 1rem;
  padding: 1rem;
  background: var(--grad-primary);
  color: #ffffff;
  border: none;
  border-radius: var(--radius-md);
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}

.submit-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.4);
}

.submit-button:disabled {
  background: rgba(245, 158, 11, 0.3);
  color: rgba(255, 255, 255, 0.5);
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.success-message {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem;
  background: rgba(16, 185, 129, 0.1);
  color: var(--color-emerald);
  border: 1px solid rgba(16, 185, 129, 0.2);
  border-radius: var(--radius-md);
  font-weight: 600;
  margin-top: 1rem;
}

.success-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: var(--color-emerald);
  color: #ffffff;
  border-radius: 50%;
  font-size: 12px;
  font-weight: bold;
}

@media (max-width: 768px) {
  .transfer-container {
    padding: 2rem 1.5rem;
  }
  
  .transfer-tabs {
    flex-direction: column;
  }
  
  .datetime-picker {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Transfer.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;;;;EAIE,WAAW;EACX,qBAAqB;EACrB,iCAAiC;EACjC,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yDAAwR;EACxR,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;EAIE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;EAClC,iCAAiC;EACjC,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA,wEAAwE;AACxE;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,mCAAmC;EACnC,2BAA2B;EAC3B,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* ==========================================\n   Kubersetu Transfer Page Glass Styles\n   ========================================== */\n\n.transfer-page {\n  font-family: var(--font-family);\n  min-height: 100vh;\n  padding: 6rem 1.5rem 4rem 1.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.transfer-container {\n  background: var(--bg-glass-card);\n  backdrop-filter: blur(20px);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  width: 100%;\n  max-width: 600px;\n  padding: 3rem 2.5rem;\n  margin: 0;\n}\n\n.transfer-header {\n  text-align: center;\n  margin-bottom: 2.5rem;\n}\n\n.transfer-header h1 {\n  color: #ffffff;\n  font-size: clamp(1.75rem, 4vw, 2.25rem);\n  font-weight: 800;\n  margin: 0 0 0.5rem 0;\n}\n\n.transfer-header p {\n  color: var(--text-muted);\n  margin: 0;\n  font-size: 1rem;\n}\n\n.transfer-tabs {\n  display: flex;\n  background: rgba(15, 23, 42, 0.7);\n  border-radius: var(--radius-md);\n  padding: 0.25rem;\n  margin-bottom: 2.5rem;\n  border: 1px solid var(--border-glass);\n}\n\n.transfer-tabs button {\n  flex: 1;\n  padding: 0.85rem 1rem;\n  border: none;\n  background: transparent;\n  border-radius: var(--radius-sm);\n  font-weight: 600;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.transfer-tabs button.active {\n  background: var(--grad-primary);\n  color: #ffffff;\n  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);\n}\n\n.transfer-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.form-section label {\n  font-weight: 500;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.account-selector select,\n.recipient-section input,\n.amount-input input,\n.datetime-picker input {\n  width: 100%;\n  padding: 1rem 1.25rem;\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-md);\n  font-size: 1rem;\n  color: #ffffff;\n  transition: all 0.3s ease;\n}\n\n.account-selector select {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23a5b4fc' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 1rem center;\n  background-size: 1rem;\n  cursor: pointer;\n}\n\n.account-selector select option {\n  background: #0f172a;\n  color: #ffffff;\n}\n\n.account-selector select:focus,\n.recipient-section input:focus,\n.amount-input input:focus,\n.datetime-picker input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);\n}\n\n.recent-contacts {\n  margin-top: 0.5rem;\n}\n\n.recent-contacts p {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  margin: 0 0 0.75rem 0;\n}\n\n.contact-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.contact-chip {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.5rem 1rem 0.5rem 0.5rem;\n  background: rgba(15, 23, 42, 0.4);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-full);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.contact-chip:hover {\n  background: rgba(15, 23, 42, 0.8);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.contact-initial {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  background: var(--grad-primary);\n  color: #ffffff;\n  border-radius: 50%;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.contact-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.contact-name {\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: #ffffff;\n}\n\n.contact-details {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n.amount-input {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.currency-symbol {\n  position: absolute;\n  left: 1.25rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--color-primary);\n  z-index: 1;\n}\n\n.amount-input input {\n  padding-left: 2.75rem;\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.schedule-options {\n  display: flex;\n  gap: 1.5rem;\n}\n\n.radio-option {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  font-weight: 500;\n  color: #ffffff;\n}\n\n.radio-option input {\n  display: none;\n}\n\n.radio-custom {\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--border-glass);\n  border-radius: 50%;\n  display: inline-block;\n  position: relative;\n  transition: all 0.2s ease;\n  background: rgba(15, 23, 42, 0.6);\n}\n\n.radio-option input:checked + .radio-custom {\n  border-color: var(--color-primary);\n  background: var(--color-primary);\n}\n\n.radio-option input:checked + .radio-custom::after {\n  content: '';\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: 8px;\n  height: 8px;\n  background: white;\n  border-radius: 50%;\n}\n\n.datetime-picker {\n  display: flex;\n  gap: 1rem;\n  margin-top: 0.5rem;\n}\n\n/* Fix for date/time picker icon colors on dark theme in some browsers */\n::-webkit-calendar-picker-indicator {\n  filter: invert(1);\n  opacity: 0.7;\n}\n\n.submit-button {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: var(--grad-primary);\n  color: #ffffff;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 1.1rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.submit-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.4);\n}\n\n.submit-button:disabled {\n  background: rgba(245, 158, 11, 0.3);\n  color: rgba(255, 255, 255, 0.5);\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n\n.success-message {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 1rem;\n  background: rgba(16, 185, 129, 0.1);\n  color: var(--color-emerald);\n  border: 1px solid rgba(16, 185, 129, 0.2);\n  border-radius: var(--radius-md);\n  font-weight: 600;\n  margin-top: 1rem;\n}\n\n.success-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  background: var(--color-emerald);\n  color: #ffffff;\n  border-radius: 50%;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n@media (max-width: 768px) {\n  .transfer-container {\n    padding: 2rem 1.5rem;\n  }\n  \n  .transfer-tabs {\n    flex-direction: column;\n  }\n  \n  .datetime-picker {\n    flex-direction: column;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
